var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoleCrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.98,49.5l-9.03,7.02,5.87,4.54-10.84,7.43v-.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.16,50.5l1.82-2.27-5.45,.45-2.73-3.64-2.73,4.55-1.36-4.55h-7.27l2.73-2.73-3.18-1.92-1-2.4,2,1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.63,45.5l5.49-2.68,4.57-.45,2.29,1.34-3.66-9.38v-1.34l-7.31-4.02-5.03-8.48,1.83,.89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.44,35.12l7.43,4.38v-6.56M28.98,7.12l.46-2.62,6.04,10.94-.93,8.75,2.32,7v1.75m0,0l3.71,6.56,3.71-4.38,1.39,3.06,3.71-5.25,3.71-3.5-1.39-7.88,2.79-6.12,.46,2.62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.9,36.37v6.02l3.92-1.93m11.31-6.24s.46,.43,1.38-1.72l-8.77,6.02-3.92,1.94m0,0l-1.62,5.8,.92,3.44,2.77,1.08m15.69,2.36l1.38-1.29-12,3.01-2.31-3.01-2.77-1.07m0,0h-5.08l-2.31-1.08,.46,2.36m5.54,22.15l-1.38,1.29,.69-4.3-3-4.73-4.62-2.15,3.23-4.73v-5.16l-.46-2.37m0,0l-3.69-2.36v3.44l-2.77-4.3-4.15,3.01-1.38-1.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoleCrack);
export default __webpack_public_path__ + "static/media/hole_crack.31b433d16747419b1d2771d181991a1e.svg";
export { ForwardRef as ReactComponent };